import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CREW_COOKIE_KEY = 'mutagim_crew_ref';
const COOKIE_EXPIRY_DAYS = 30;

/**
 * Hook pour tracker les liens de parrainage Crew
 * Détecte ?ref=CODE dans l'URL et sauvegarde en localStorage
 */
export function useCrewTracking() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get('ref');
    
    if (refCode) {
      // Sauvegarder le code dans localStorage avec expiration
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);
      
      const cookieData = {
        code: refCode.toUpperCase(),
        expires: expiryDate.toISOString(),
      };
      
      localStorage.setItem(CREW_COOKIE_KEY, JSON.stringify(cookieData));
      
      // Enregistrer le clic côté serveur
      fetch(`${API_URL}/api/crew/track-click?code=${refCode}`, {
        method: 'POST',
      }).catch(console.error);
      
      // Nettoyer l'URL (retirer ?ref=)
      searchParams.delete('ref');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);
}

/**
 * Récupérer le code Crew actif depuis le cookie
 */
export function getCrewRefCode(): string | null {
  try {
    const stored = localStorage.getItem(CREW_COOKIE_KEY);
    if (!stored) return null;
    
    const data = JSON.parse(stored);
    const expiryDate = new Date(data.expires);
    
    // Vérifier expiration
    if (expiryDate < new Date()) {
      localStorage.removeItem(CREW_COOKIE_KEY);
      return null;
    }
    
    return data.code;
  } catch {
    return null;
  }
}

/**
 * Effacer le cookie Crew (après utilisation d'un code promo)
 */
export function clearCrewRefCode() {
  localStorage.removeItem(CREW_COOKIE_KEY);
}

export default useCrewTracking;
